import type { ApiErrorBody, ApiSuccess } from "../../shared/types";

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly issues: ApiErrorBody["error"]["issues"];

  constructor(status: number, body: ApiErrorBody) {
    super(body.error.message);
    this.name = "ApiError";
    this.status = status;
    this.code = body.error.code;
    this.issues = body.error.issues;
  }
}

function isErrorBody(value: unknown): value is ApiErrorBody {
  if (typeof value !== "object" || value === null) return false;
  const error = Reflect.get(value, "error") as unknown;
  if (typeof error !== "object" || error === null) return false;
  return typeof Reflect.get(error, "code") === "string" && typeof Reflect.get(error, "message") === "string";
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const response = await fetch(path, { ...init, headers, credentials: "same-origin" });
  let payload: unknown = null;
  if (response.headers.get("content-type")?.includes("application/json")) {
    payload = await response.json();
  }
  if (!response.ok) {
    const body: ApiErrorBody = isErrorBody(payload)
      ? payload
      : { error: { code: "REQUEST_FAILED", message: `请求失败（${response.status}）` } };
    throw new ApiError(response.status, body);
  }
  if (typeof payload !== "object" || payload === null || !("data" in payload)) {
    throw new ApiError(500, {
      error: { code: "INVALID_RESPONSE", message: "服务器返回了无法识别的数据" },
    });
  }
  return (payload as ApiSuccess<T>).data;
}

export function jsonBody(value: unknown): Pick<RequestInit, "body"> {
  return { body: JSON.stringify(value) };
}

